import { cn } from "design-system/utils"
import { useTranslation } from "react-i18next"

type CustomerLike = {
  name?: string | null
  email?: string | null
  tentativeName?: string | null
  tentativeEmail?: string | null
  instagramProfile?: {
    name?: string | null
    username?: string | null
  } | null
}

type Props = {
  customer: CustomerLike
}

export function CustomerCell({ customer }: Props) {
  const { t } = useTranslation()
  const isEmphasized = !!customer.name?.length || !!customer.email?.length

  return (
    <span className={cn(isEmphasized ? "font-medium" : "text-muted-foreground")}>
      {customer.name ||
        customer.email ||
        customer.tentativeName ||
        customer.tentativeEmail ||
        customer.instagramProfile?.name ||
        customer.instagramProfile?.username ||
        t("customers.profile.noName")}
    </span>
  )
}
